const _system = {
    id: {
        count: 0, // Counter for programs that need unique ID
        prefix: 'l-'
    }
};

export default _system;
